/*
 * Copyright 2022, TeamDev. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Redistribution and use in source and/or binary forms, with or without
 * modification, must retain the above copyright notice and the following
 * disclaimer.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpEndpoint = void 0;

var _typedMessage = require("./typed-message");

var _errors = require("./errors");

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * @typedef {Object} SubscriptionRouting
 *
 * @property {string} create
 *  the name of the subscription creation endpoint; defaults to "/subscription/create"
 * @property {string} keepUp
 *  the name of the subscription keep up endpoint; defaults to "/subscription/keep-up"
 * @property {string} cancel
 *  the name of the subscription cancellation endpoint; defaults to "/subscription/cancel"
 */

/**
 * @typedef {Object} Routing
 *
 * @property {string} query
 *  the name of the query endpoint; defaults to "/query"
 * @property {string} command
 *  the name of the command endpoint; defaults to "/command"
 * @property {!SubscriptionRouting} subscription
 *  the config of the subscription endpoints
 */
var Endpoint = /*#__PURE__*/function () {
  function Endpoint() {
    _classCallCheck(this, Endpoint);
  }

  _createClass(Endpoint, [{
    key: "command",
    value:
    /**
     * Sends off a command to the endpoint.
     *
     * @param {!TypedMessage<Command>} command a Command  to send to the Spine server
     * @return {Promise<Object>} a promise of a successful server response, rejected if
     *                           an error occurs
     */
    function command(_command) {
      return this._executeCommand(_command);
    }
    /**
     * Sends off a query to the endpoint.
     *
     * @param {!spine.client.Query} query a Query to Spine server to retrieve some domain entities
     * @return {Promise<Object>} a promise of a successful server response, rejected if
     *                           an error occurs
     */

  }, {
    key: "query",
    value: function query(_query) {
      var typedQuery = _typedMessage.TypedMessage.of(_query);

      return this._performQuery(typedQuery);
    }
    /**
     * Sends off a request to subscribe to a provided topic to an endpoint.
     *
     * @param {!spine.client.Topic} topic a topic for which a subscription is created
     * @return {Promise<Object>} a promise of a successful server response, rejected if
     *                           an error occurs
     */

  }, {
    key: "subscribeTo",
    value: function subscribeTo(topic) {
      var typedTopic = _typedMessage.TypedMessage.of(topic);

      return this._subscribeTo(typedTopic);
    }
    /**
     * Sends off a request to keep a subscription, stopping it from being closed by server.
     *
     * @param {!spine.client.Subscription} subscription a subscription that should be kept open
     * @return {Promise<Object>} a promise of a successful server response, rejected if
     *                           an error occurs
     */

  }, {
    key: "keepUpSubscription",
    value: function keepUpSubscription(subscription) {
      var typedSubscription = _typedMessage.TypedMessage.of(subscription);

      return this._keepUp(typedSubscription);
    }
    /**
     * Sends off a request to cancel an existing subscription.
     *
     * Cancelling subscription stops the server updating subscription with new values.
     *
     * @param {!spine.client.Subscription} subscription a subscription that should be kept open
     * @return {Promise<Object>} a promise of a successful server response, rejected if
     *                           an error occurs
     */

  }, {
    key: "cancelSubscription",
    value: function cancelSubscription(subscription) {
      var typedSubscription = _typedMessage.TypedMessage.of(subscription);

      return this._cancel(typedSubscription);
    }
    /**
     * @param {!TypedMessage<Command>} command a Command to send to the Spine server
     * @return {Promise<Object>} a promise of a successful server response, rejected if
     *                           an error occurs
     * @protected
     * @abstract
     */

  }, {
    key: "_executeCommand",
    value: function _executeCommand(command) {
      throw new Error('Not implemented in abstract base.');
    }
    /**
     * @param {!TypedMessage<Query>} query a Query to Spine server to retrieve some domain entities
     * @return {Promise<Object>} a promise of a successful server response, rejected if
     *                           an error occurs
     * @protected
     * @abstract
     */

  }, {
    key: "_performQuery",
    value: function _performQuery(query) {
      throw new Error('Not implemented in abstract base.');
    }
    /**
     * @param {!TypedMessage<spine.client.Topic>} topic a topic to create a subscription for
     * @return {Promise<Object>} a promise of a successful server response, rejected if
     *                           an error occurs
     * @protected
     * @abstract
     */

  }, {
    key: "_subscribeTo",
    value: function _subscribeTo(topic) {
      throw new Error('Not implemented in abstract base.');
    }
    /**
     * @param {!TypedMessage<spine.client.Subscription>} subscription a subscription to keep alive
     * @return {Promise<Object>} a promise of a successful server response, rejected if
     *                           an error occurs
     * @protected
     * @abstract
     */

  }, {
    key: "_keepUp",
    value: function _keepUp(subscription) {
      throw new Error('Not implemented in abstract base.');
    }
    /**
     * @param {!TypedMessage<spine.client.Subscription>} subscription a subscription to be canceled
     * @return {Promise<Object>} a promise of a successful server response, rejected if
     *                           an error occurs
     * @protected
     * @abstract
     */

  }, {
    key: "_cancel",
    value: function _cancel(subscription) {
      throw new Error('Not implemented in abstract base.');
    }
  }]);

  return Endpoint;
}();
/**
 * Spine HTTP endpoint which is used to send off Commands and Queries using
 * the provided HTTP client.
 */


var HttpEndpoint = /*#__PURE__*/function (_Endpoint) {
  _inherits(HttpEndpoint, _Endpoint);

  var _super = _createSuper(HttpEndpoint);

  /**
   * @param {!HttpClient} httpClient a client sending requests to server
   * @param {Routing} routing endpoint routing parameters
   */
  function HttpEndpoint(httpClient, routing) {
    var _this;

    _classCallCheck(this, HttpEndpoint);

    _this = _super.call(this);
    _this._httpClient = httpClient;
    _this._routing = routing;
    return _this;
  }
  /**
   * Sends off a command to the endpoint.
   *
   * @param {!TypedMessage<Command>} command a Command to send to the Spine server
   * @return {Promise<Object|SpineError>} a promise of a successful server response JSON data,
   *                                      rejected if the client response is not 2xx or a
   *                                      connection error occurs
   * @protected
   */


  _createClass(HttpEndpoint, [{
    key: "_executeCommand",
    value: function _executeCommand(command) {
      var path = this._routing && this._routing.command || '/command';
      return this._sendMessage(path, command);
    }
    /**
     * Sends off a query to the endpoint.
     *
     * @param {!TypedMessage<Query>} query a Query to Spine server to retrieve some domain entities
     * @return {Promise<Object|SpineError>} a promise of a successful server response JSON data,
     *                                      rejected if the client response is not 2xx or a
     *                                      connection error occurs
     * @protected
     */

  }, {
    key: "_performQuery",
    value: function _performQuery(query) {
      var path = this._routing && this._routing.query || '/query';
      return this._sendMessage(path, query);
    }
    /**
     * Sends off a request to create a subscription for a topic.
     *
     * @param {!TypedMessage<spine.client.Topic>} topic a topic to subscribe to
     * @return {Promise<Object|SpineError>} a promise of a successful server response JSON data,
     *                                      rejected if the client response is not 2xx or a
     *                                      connection error occurs
     * @protected
     */

  }, {
    key: "_subscribeTo",
    value: function _subscribeTo(topic) {
      var path = this._routing && this._routing.subscription && this._routing.subscription.create || '/subscription/create';
      return this._sendMessage(path, topic);
    }
    /**
     * Sends off a request to keep alive a subscription.
     *
     * @param {!TypedMessage<spine.client.Subscription>} subscription a subscription that is prevented
     *                                                                  from being closed by server
     * @return {Promise<Object|SpineError>} a promise of a successful server response JSON data,
     *                                      rejected if the client response is not 2xx or a
     *                                      connection error occurs
     * @protected
     */

  }, {
    key: "_keepUp",
    value: function _keepUp(subscription) {
      var path = this._routing && this._routing.subscription && this._routing.subscription.keepUp || '/subscription/keep-up';
      return this._sendMessage(path, subscription);
    }
    /**
     * Sends off a request to cancel a subscription.
     *
     * @param {!TypedMessage<spine.client.Subscription>} subscription a subscription to be canceled
     * @return {Promise<Object|SpineError>} a promise of a successful server response JSON data,
     *                                      rejected if the client response is not 2xx or a
     *                                      connection error occurs
     * @protected
     */

  }, {
    key: "_cancel",
    value: function _cancel(subscription) {
      var path = this._routing && this._routing.subscription && this._routing.subscription.cancel || '/subscription/cancel';
      return this._sendMessage(path, subscription);
    }
    /**
     * Sends the given message to the given endpoint.
     *
     * @param {!string} endpoint an endpoint to send the message to
     * @param {!TypedMessage} message a message to send, as a {@link TypedMessage}
     * @return {Promise<Object|SpineError>} a promise of a successful server response JSON data,
     *                                      rejected if the client response is not 2xx or a
     *                                      connection error occurs
     * @private
     */

  }, {
    key: "_sendMessage",
    value: function _sendMessage(endpoint, message) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2._httpClient.postMessage(endpoint, message).then(HttpEndpoint._jsonOrError, HttpEndpoint._connectionError).then(resolve, reject);
      });
    }
    /**
     * Retrieves the JSON data from the given response if it was successful, rejects
     * with a respective error otherwise.
     *
     * @param {!Response} response an HTTP request response
     * @return {Promise<Object|SpineError>} a promise of a successful server response JSON data,
     *                                      rejected if the client response is not 2xx or if JSON
     *                                      parsing fails
     * @private
     */

  }], [{
    key: "_jsonOrError",
    value: function _jsonOrError(response) {
      var statusCode = response.status;

      if (HttpEndpoint._isSuccessfulResponse(statusCode)) {
        return HttpEndpoint._parseJson(response);
      } else if (HttpEndpoint._isClientErrorResponse(statusCode)) {
        return Promise.reject(new _errors.ClientError(response.statusText, response));
      } else if (HttpEndpoint._isServerErrorResponse(statusCode)) {
        return Promise.reject(new _errors.ServerError(response));
      }
    }
    /**
     * Parses the given response JSON data, rejects if parsing fails.
     *
     * @param {!Response} response an HTTP request response
     * @return {Promise<Object|SpineError>} a promise of a server response parsing to be fulfilled
     *                                      with a JSON data or rejected with {@link SpineError} if
     *                                      JSON parsing fails.
     * @private
     */

  }, {
    key: "_parseJson",
    value: function _parseJson(response) {
      return response.json().then(function (json) {
        return Promise.resolve(json);
      })["catch"](function (error) {
        return Promise.reject(new _errors.SpineError('Failed to parse response JSON', error));
      });
    }
    /**
     * Gets the error caught from the {@link HttpClient#postMessage} and returns
     * a rejected promise with a given error wrapped into {@link ConnectionError}.
     *
     * @param {!Error} error              an error which occurred upon message sending
     * @return {Promise<ConnectionError>} a rejected promise with a `ConnectionError`
     * @private
     */

  }, {
    key: "_connectionError",
    value: function _connectionError(error) {
      return Promise.reject(new _errors.ConnectionError(error));
    }
    /**
     * @param {!number} statusCode an HTTP request response status code
     * @return {boolean} `true` if the response status code is from 200 to 299, `false` otherwise
     * @private
     */

  }, {
    key: "_isSuccessfulResponse",
    value: function _isSuccessfulResponse(statusCode) {
      return 200 <= statusCode && statusCode < 300;
    }
    /**
     * @param {!number} statusCode an HTTP request response status code
     * @return {boolean} `true` if the response status code is from 400 to 499, `false` otherwise
     * @private
     */

  }, {
    key: "_isClientErrorResponse",
    value: function _isClientErrorResponse(statusCode) {
      return 400 <= statusCode && statusCode < 500;
    }
    /**
     * @param {!number} statusCode an HTTP request response status code
     * @return {boolean} `true` if the response status code is from 500, `false` otherwise
     * @private
     */

  }, {
    key: "_isServerErrorResponse",
    value: function _isServerErrorResponse(statusCode) {
      return 500 <= statusCode;
    }
  }]);

  return HttpEndpoint;
}(Endpoint);

exports.HttpEndpoint = HttpEndpoint;
//# sourceMappingURL=http-endpoint.js.map